/** Small date/label helpers shared by the pages. */

export function fmtDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}

/** "$55,000 / YEAR" from minor units, or null when unset. */
export function fmtSalary(
  currency: string | null,
  period: string | null,
  minMinor: number | null,
): string | null {
  if (minMinor == null || !currency) return null;
  const major = minMinor / 100;
  let amount: string;
  try {
    amount = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency,
      maximumFractionDigits: 0,
    }).format(major);
  } catch {
    amount = `${currency} ${major.toLocaleString()}`;
  }
  return period ? `${amount} / ${period.toLowerCase()}` : amount;
}

export function shortId(id: string): string {
  return id.length > 8 ? `${id.slice(0, 8)}…` : id;
}
